import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "top-bar"
};
var _hoisted_2 = {
  class: "logo"
};
var _hoisted_3 = {
  class: "tab"
};
var _hoisted_4 = ["onClick"];
import { ref, watch, inject } from 'vue';
import { TOP_BAR } from './const';

/* 变量 */

export default {
  __name: 'TopBar',
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var discussInfo = inject('discussInfo');
    var emit = __emit;
    var tabs = ref([]);
    var tabId = ref(1);

    /* 监听 */
    watch(discussInfo, function (info) {
      var _info$functionConfig;
      var auth = (info === null || info === void 0 || (_info$functionConfig = info.functionConfig) === null || _info$functionConfig === void 0 ? void 0 : _info$functionConfig.split(',')) || [];
      tabs.value = TOP_BAR.filter(function (e) {
        return auth.includes(e.id.toString());
      });
    }, {
      immediate: true,
      deep: true
    });

    /* 事件 */
    var tabChange = function tabChange(item) {
      tabId.value = item.id;
      emit('change', item.id);
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
        name: "discuss-logo",
        size: "36"
      }), _cache[0] || (_cache[0] = _createElementVNode("span", null, "教师研讨", -1))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass({
            active: tabId.value === item.id
          }),
          onClick: function onClick($event) {
            return tabChange(item);
          }
        }, [_createElementVNode("span", null, _toDisplayString(item.name), 1)], 10, _hoisted_4);
      }), 128))])]);
    };
  }
};